const UserManegementTableBelowContent = {
  TABLEBELOWCONTENT:
    "Workflow will start after a vendor clicks submit the documents, thenthe document will be sent to the concerned party along the workflow diagram.",
};

module.exports = {
  UserManegementTableBelowContent,
};
